import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    arrowUp: { transform: [{ rotate: '90deg' }] },
    arrowDown: { transform: [{ rotate: '270deg' }] },
    arrowDisabled: { opacity: 0.5 },
});

export default styles;
